import { v4 as uuidv4 } from 'uuid'

import { BlockModel } from '@client/components/Block/model'
import { FIELD_TYPES } from '@client/components/Block/constants'
import { defaultSettings } from './constants'
import { getNewChoice } from '@client/utils/handleAddAnswerCommon'

export default class SelectOneModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    this.editor = editor

    this.fieldType = data.fieldType || FIELD_TYPES.NULL

    this.inputName = data.inputName || uuidv4()

    const settings = { ...defaultSettings, ...data.settings }

    if (!settings.choices || !settings.choices.length) {
      settings.choices = [getNewChoice([])]
    }

    this.settings.set(settings)
  }

  serialize = () => {
    return {
      type: this.type,
      fieldType: this.fieldType,
      settings: this.settings.serialize(),
      inputName: this.inputName,
    }
  }

  restore = (data) => {
    this.type = data.type
    this.fieldType = data.fieldType
    this.settings.set(data.settings)
    this.inputName = data.inputName
  }
}

export const NULL = new SelectOneModel()
